import { EditorState, type Extension } from "@codemirror/state";
import { EditorView } from "@codemirror/view";

/** The CodeMirror side of the view-only studio (editsLocked): no typing,
 *  no paste, no command that changes the document — the text stays
 *  scrollable, selectable and copyable. Empty while edits are allowed. */
export function viewOnlyExtensions(locked: boolean): Extension[] {
  return locked
    ? [EditorState.readOnly.of(true), EditorView.editable.of(false)]
    : [];
}
